<template>
    <div>
        <topnav></topnav>
        <div class="bggray conall flex justify-center align-center">
            <el-image class="leftimg" src="/static/assets/images/index/img4.png" fit="fill"></el-image>
            <div class="bg-white rightcon">
                <div class="con">
                    <div class="toptab flex justify-center align-center">
                        <!-- <div @click="ctab(1)" class="tabone pointer" :class="tabindex == 1 ? 'active' : ''">管理员登录</div> -->
                        <!-- <div @click="ctab(2)" class="tabone pointer" :class="tabindex == 2 ? 'active' : ''">个人登录</div> -->
                        <div @click="ctab(2)" class="tabone pointer">扫码登录</div>
                    </div>
                    <div v-if="tabindex == 1" class="newinput">
                        <el-input v-model="username" placeholder="请输入您的账户" prefix-icon="el-icon-user"></el-input>
                        <el-input v-model="password" type="password" style="margin-top: 30px;" placeholder="请输入密码" prefix-icon="el-icon-lock"></el-input>
                        <div @click="tosub" class="newbtn pointer">登     录</div>
                    </div>
                    <div v-if="tabindex == 2" @click="tonext(2)" class="flex flex-direction justify-center align-center margin-top">
                        <el-image style="width: 230px;height: 230px;display: block;" :src="qrcode | addurl" fit="fill"></el-image>
                        <div class="text-center" style="color: #ff9d11;font-size: 20px;margin-top: 20px;">请使用微信扫描二维码登录</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    data() {
        return{
            tabindex: 2,
            username: '',
            password: '',
            qrcode: '',
            timer: null,
        }
    },
    computed: {
        
    },
    methods:{
        ctab(e){
            this.tabindex = e;
            if(e == 2){
                this.getqrcode();
            }else{
                clearInterval(this.timer);
            }
        },
        getqrcode(){
            this.$api.user.web_login().then(res=>{
                console.log(res)
                this.qrcode = res.data.path;
                var sign = res.data.sign;
                this.timer = setInterval(() => {
                    this.checkstatus(sign)
                }, 1000);
            })
        },
        checkstatus(sign){
            var data = {
                sign: sign
            }
            this.$api.user.checkStatus(data).then(response=>{
                console.log('responseresponseresponseresponse',response)
                if(response.data == 1){
                    this.$message({
                        message: '登录成功',
                        type: 'success',
                        duration: 1000
                    });
                    localStorage.setItem('type',2)
                    var user_id = response.user_id;
                    this.$store.dispatch('user/userinfo',user_id)
                    setTimeout(()=>{
                        this.$router.push({ path: '/'});
                    },1000)
                }
            })
            // checkStatus
        },
        tonext(e){
            if(e == 1){
                this.$router.push({path: '/system'})
            }else{
                this.$router.push({path: '/personal'})
            }
        },
        tosub(){
            if(!this.username){
                this.$message.error('请输入您的账户')
            }
            if(!this.password){
                this.$message.error('请输入您的密码')
            }
            var data = {
                username: this.username,
                password: this.password
            }
            this.$store.dispatch("user/admin_login",data).then(() => {
                localStorage.setItem('type',1)
                this.$router.push({ path: "/" });
            })
            // this.$api.index.admin_login(data).then(response => {
            //     console.log(response)
            // })
        },
    },
    created(){
        this.getqrcode();
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
}
</script>
<style >
    .newinput .el-input__inner{
        border-radius: 0px;
        border-top-width: 0px;
        border-left-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
    }
</style>
<style  scoped>
    .bggray{
        background-color: #eef1fa;
    }
    .conall{
        padding: 80px 0;
    }
    .rightcon{
        width: 565px;height: 575px;
        box-shadow: 0px 3px 57px 0px rgba(162, 178, 209, 0.31);border-radius: 10px;
    }
    .leftimg{
        width: 457px;margin-right: 60px;display: block;
        /* height: 566px; */
    }
    .con{
        margin: 75px 85px 0 85px;
    }
    .tabone{
        width: 200px;
        padding: 15px;text-align: center;
        color: #444444;font-size: 24px;
        border-bottom: 3px solid #fff;
    }
    .active{
        color: #1660ed;
        border-bottom: 3px solid #1660ed;
    }
    .newinput{
        margin-top: 70px;
    }
    .newbtn{
        width: 100%;
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: #fff;font-size: 24px;
        background-color: #1660ed;
        margin-top: 80px;border-radius: 8px;
    }
</style>


// WEBPACK FOOTER //
// login.vue?eee9f154